import { ICasino } from 'constants/types';
import { LoadMoreButton } from 'components/load-more-button';

import styles from './styles.module.css';
import { useCasinoReviewsPaginationNoCache } from 'hooks/useCasinoReviewsPaginationNoCache';
import { Anchor } from 'constants/anchors';
import { TableCommentsCasino } from './table-comments';

type Props = {
  casino: ICasino;
};

export const ReviewTableCommentsCasino = ({ casino }: Props) => {
  const {
    isLast,
    page,
    setPage,
    resetData,
    refetchData,
    data: paginationCasinoReviewsData,
    isFetching,
  } = useCasinoReviewsPaginationNoCache({
    casinoId: casino._id,
    limit: 4,
  });

  return (
    <div className={styles.wrapper}>
      <div id={Anchor.CasinoReviews} className="anchor" />

      <TableCommentsCasino
        type={'casino'}
        entity={casino}
        hasHeader
        onSuccess={() => {
          resetData();
          refetchData();
        }}
        count={paginationCasinoReviewsData?.length ?? 0}
        data={paginationCasinoReviewsData}
      />
      {!isLast && (
        <LoadMoreButton
          isAuto={false}
          isVisible={true}
          onClick={() => setPage(page + 1)}
          isFetching={isFetching}
          className={styles.loadmoreButton}
          description="Load more"
          variant="transparent"
        />
      )}
    </div>
  );
};
